import { render } from "./TopInfluencer.vue?vue&type=template&id=71dc25ae&scoped=true"
import script from "./TopInfluencer.vue?vue&type=script&lang=js"
export * from "./TopInfluencer.vue?vue&type=script&lang=js"

import "./TopInfluencer.vue?vue&type=style&index=0&id=71dc25ae&lang=scss&scoped=true"
import "./TopInfluencer.vue?vue&type=style&index=1&id=71dc25ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc25ae"]])

export default __exports__